<template>
<div style="width:100%;" class="resp-iframe-container">
      <!-- cc-fields-view triggers a different view, iframe still rendered -->
    <div :class="{'cc-fields-view': showCCFields}">
        <!-- header section -->
        <div class="table-header"  v-if="showCCFields">
            <span class="has-text-weight-bold">Card Information</span>
            <span class="has-text-danger">*Denotes a required field</span>
        </div>

        <div class="payment-body">

            <div class="is-flex">
                <!-- explicitly define text here since not in iFrame -->
                <p id ="card-number-txt" v-if="showCCFields">
                    <span class="has-text-danger">*</span>Card Number
                </p>

                    <!-- PAYMENT IFRAME -->
                <iframe
                    ref="addPaymentIFrame"
                    @load="handleIFrameResponse()"
                    id="payment-iframe"
                    class="resp-frame"
                    frameborder="0"
                    :src="getIframeSrc()"
                    v-show="!showCaptchaForElement"
                ></iframe>
              <div class="element-captcha" v-if="showCaptchaForElement">
                <div>Solve the ReCaptcha below to finish adding your card</div>
                <vue-recaptcha class="captcha" ref="recaptcha-element" sitekey="6Lf-pLAaAAAAAJ0ZsozWeONpewCOaQXNyW8hal89" @verify="reCaptchaResponse" @expired="reCaptchaResponse(null)" @error="reCaptchaResponse(null)"></vue-recaptcha>

              </div>

            </div>

                <!-- IF NEEEDED TO COLLECT EXPIRATION DATE -->
            <div id="cc-fields" v-if="showCCFields">
                <horizontal-input :labelClasses="'cc-label has-text-left'" class="is-flex">
                    <template slot="label">
                        <span id="expiration-txt" class="has-text-weight-normal is-size-6"> <span class="has-text-danger">*</span>
                            Expiration
                        </span>
                    </template>
                    <div slot="body" class="flex-column control-group">
                        <credit-card-expiration @dateChosen="dateChosen" />
                    </div>
                </horizontal-input>
            </div>

        </div>

    </div>
    <vue-recaptcha v-if="showCCFields" class="captcha" ref="recaptcha-cc" sitekey="6Lf-pLAaAAAAAJ0ZsozWeONpewCOaQXNyW8hal89" @verify="reCaptchaResponse" @expired="reCaptchaResponse(null)" @error="reCaptchaResponse(null)"></vue-recaptcha>
    <BaseButton
          v-if="showCCFields"
          :classNames="['button payment-btn is-rounded nav-btn']"
          @click="$emit('addPayment')"
          :disabled="!captchaSolved"
          title="Process"></BaseButton>


</div>
</template>


<script>
import { LOCATION } from '../../../stores/defs';
import { mapGetters } from 'vuex';
import { PAYMENT_ENDPOINTS } from '@/services/payment.service';
import { EPaymentServiceType } from '@/models/interfaces/Payment/EPaymentServiceType';
import CreditCardExpiration from '../payment/CreditCardExpiration';
import HorizontalInput from "@/components/form/HorizontalInput";
import VueRecaptcha from 'vue-recaptcha';
import { getParam } from '@/utils/helper.functions';

export default {
    props: {
      iFrameProps: {
          default: null
      }
    },
    components: {
        'credit-card-expiration': CreditCardExpiration,
        'horizontal-input': HorizontalInput,
        'vue-recaptcha': VueRecaptcha
	},
    computed: {
        ...mapGetters({
            location: LOCATION.GET_LOCATION
        }),
        showCCFields() {
            return this.location.paymentServiceType === EPaymentServiceType.TYPE_CC;
        },
        captchaSolved() {
          return this.solvedCaptcha !== null;
        }
    },
    data() {
        return {
            tokenObj: {
                hppUrl: null,
            },
          solvedCaptcha: null,
          showCaptchaForElement: false
        }
    },
    methods: {
        reCaptchaResponse($event) {
          this.solvedCaptcha = $event;
          this.$emit('captchaSolved', this.solvedCaptcha);
          if (this.location.paymentServiceType === EPaymentServiceType.TYPE_E) {
            this.$emit('iFrameEvent', this.getElementIframeResponse());
          }
        },
        getIframeSrc() {
            if (this.location.paymentServiceType === EPaymentServiceType.TYPE_E && this.iFrameProps && this.iFrameProps.hppUrl) {
                return this.iFrameProps.hppUrl;
            } else if (this.location.paymentServiceType === EPaymentServiceType.TYPE_CC) {
                return PAYMENT_ENDPOINTS.TYPE_CC.IFRAME();
            }
        },
        getElementIframeResponse() {
          try {
            const query = this.$refs.addPaymentIFrame.contentWindow.location.search;
            const status = getParam('HostedPaymentStatus', this.$refs.addPaymentIFrame.contentWindow.location);
            const response = {
              query: query,
              status: status
            };
            return response;
          } catch (err) {
            // Actually don't log, it's just a bunch on cross-origin errors
            // console.error(err);
            return {
              query: null,
              status: null
            };
          }
        },
        handleIFrameResponse() {
            if (this.location.paymentServiceType === EPaymentServiceType.TYPE_E) {
              try {
                const response = this.getElementIframeResponse();
                // console.log('handleIFrameResponse', response);
                if (response.query && response.status === "Complete") {
                  // Hold this for now
                  this.showCaptchaForElement = true;
                } else if(response.status !== null) {
                  // We will let everything else go through
                  this.$emit('iFrameEvent', response);
                }
              } catch (err) {
                console.error(err);
              }
            }
        },
        dateChosen(expiry) {
            this.$emit('dateChosen', expiry);
        },
    }
}
</script>

<style lang="scss" scoped>

    .resp-iframe-container {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        min-height: 16em;
    }

    #payment-iframe {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        min-height: 16em;
        border: 0;
	}

	.link-action {
		margin-right: 1em;
	}

    .cc-fields-view {
	    border: 1px solid grey;

        .table-header {
            border-bottom: 1px solid grey;
            background-color: #F8F8F8;
            display: flex;
            justify-content: space-between;
            padding: 5px 10px;
            width: 100%;
        }

         #payment-iframe {
            width: 75%;
            height: 3.5em;
            min-height: 0em;
            margin-top: -6px;
            margin-bottom: 0em;
        }

        .payment-body {
            padding: 10px;
        }
    }

     #card-number-txt, #expiration-txt {
         min-width: 8em;
         text-align: left
     }

    /deep/ .cc-label {
		min-width: 8em;
		margin-right: 0em;
	}
    .element-captcha {

    }
    .captcha {
      margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/checkout/payment/PaymentIFrame.vue